import React from 'react';
import './App.scss';
import { Provider } from 'react-redux';
import store from './redux/store';
import ThemeProvider from './components/ThemeConfigProvider/ThemeConfigProvider';
import 'material-icons/iconfont/material-icons.css';
import ErrorPage from './startup/ErrorPageComponent/ErrorPage.component';
import { useErrorStore } from './utils/authState';
import NotificationController from './components/NotificationController/NotificationController';
import RouterComponent from './components/Router/Router.component';
import AuthInitProvider from './components/AuthInitProvier/AuthInitProvider';

function App() {
  const isFatalError = useErrorStore((state) => state.isFatalError);

  if (isFatalError) {
    return <ErrorPage onRetry={() => window.location.reload()} />;
  }

  return (
    <Provider store={store}>
      <AuthInitProvider>
        <ThemeProvider>
          <RouterComponent />
          <NotificationController />
        </ThemeProvider>
      </AuthInitProvider>
    </Provider>
  );
}

export default App;
